import React from "react";
import { motion } from "framer-motion";
import { Star, Quotes } from "@phosphor-icons/react";
import { TESTIMONIALS } from "../lib/constants";

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="py-20 lg:py-28 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-700 mb-3">
            Ils nous font confiance
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900">
            Experts en solutions énergétiques pour l'habitat
          </h2>
          <p className="text-slate-600 mt-4 text-base md:text-lg leading-relaxed">
            Des propriétaires accompagnés dans toute la France sur leurs projets
            de pompe à chaleur, rénovation énergétique et remplacement de
            chauffage.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              data-testid={`testimonial-${i}`}
              className="relative bg-white p-7 rounded-2xl border border-slate-200 shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgba(0,0,0,0.06)] transition-shadow"
            >
              <Quotes size={28} weight="fill" className="text-blue-600/20 absolute top-5 right-5" />
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} size={16} weight="fill" color="#F59E0B" />
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed text-sm mb-5">
                « {t.quote} »
              </p>
              <div className="border-t border-slate-100 pt-4">
                <div className="font-semibold text-slate-900">{t.name}</div>
                <div className="text-xs text-slate-500 mt-0.5">
                  {t.location} • {t.heating}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
